"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const Icon_1 = require("@material-ui/core/Icon");
const IconButton_1 = require("@material-ui/core/IconButton");
const Link_1 = require("@material-ui/core/Link");
const Snackbar_1 = require("@material-ui/core/Snackbar");
const SnackbarContent_1 = require("@material-ui/core/SnackbarContent");
const Typography_1 = require("@material-ui/core/Typography");
const styles_1 = require("@material-ui/core/styles");
const classnames_1 = require("classnames");
const React = require("react");
const react_i18next_1 = require("react-i18next");
const MessageBarStyle_1 = require("./jss/MessageBarStyle");
class MessageBar extends React.Component {
    constructor() {
        super(...arguments);
        this.ref = React.createRef();
        this.renderStaticBar = () => {
            const { message, type, showMessage, classes, theme, clearMessages, messageParams, t } = this.props;
            if (!showMessage) {
                return null;
            }
            let icon;
            let backgroundColor;
            let textColor;
            switch (type) {
                case 'outage_warning':
                case 'warning':
                    backgroundColor = this.props.warningColor;
                    textColor = theme.palette.text.primary;
                    icon = ((0, jsx_runtime_1.jsx)(Icon_1.default, Object.assign({ style: { color: textColor }, className: classes.icon }, { children: "warning" })));
                    break;
                case 'success_embedded':
                    backgroundColor = this.props.successColor;
                    textColor = theme.palette.text.primary;
                    icon = null;
                    break;
                case 'error':
                default:
                    backgroundColor = theme.palette.error.main;
                    textColor = theme.palette.error.contrastText;
                    icon = ((0, jsx_runtime_1.jsx)(Icon_1.default, Object.assign({ style: { color: textColor }, className: classes.icon }, { children: "error_outline" })));
                    break;
            }
            const displayMessage = type === 'outage_warning' ? message : t((message === null || message === void 0 ? void 0 : message.toString()) || '', messageParams);
            const screenReaderErrorAlert = type === 'error' ? 'alert' : '';
            return ((0, jsx_runtime_1.jsx)("div", Object.assign({ className: classes.root, style: { backgroundColor }, role: screenReaderErrorAlert, ref: this.ref, tabIndex: -1 }, { children: (0, jsx_runtime_1.jsxs)("div", Object.assign({ className: classes.innerContainer }, { children: [(0, jsx_runtime_1.jsxs)("div", Object.assign({ className: classes.textSection }, { children: [icon, (0, jsx_runtime_1.jsx)(Typography_1.default, Object.assign({ variant: "body1", className: classes.messageText, style: { color: textColor } }, { children: displayMessage })), messageParams && messageParams.linkAction ? ((0, jsx_runtime_1.jsx)(Link_1.default, Object.assign({ href: "javascript:;", onClick: messageParams.linkAction, color: 'inherit', className: classes.linkStatic }, { children: t(messageParams.linkText) }))) : null] })), clearMessages && ((0, jsx_runtime_1.jsx)("div", Object.assign({ className: classes.close }, { children: (0, jsx_runtime_1.jsx)(IconButton_1.default, Object.assign({ "aria-label": "Close Message Bar", onClick: this.onClose, className: (0, classnames_1.default)('iconButton', classes.iconButton) }, { children: (0, jsx_runtime_1.jsx)(Icon_1.default, Object.assign({ className: classes.icon, style: { color: textColor } }, { children: "close" })) })) })))] })) })));
        };
        this.renderSnackBar = () => {
            const { message, showMessage, classes, messageTimeout, messageParams, t } = this.props;
            const autoHideDuration = messageTimeout === undefined ? 3000 : messageTimeout;
            return ((0, jsx_runtime_1.jsx)(Snackbar_1.default, Object.assign({ anchorOrigin: { vertical: 'top', horizontal: 'right' }, open: showMessage, onClose: this.onClose, autoHideDuration: autoHideDuration }, { children: (0, jsx_runtime_1.jsx)(SnackbarContent_1.default, { style: { backgroundColor: this.props.successColor }, "aria-describedby": "message-id", message: (0, jsx_runtime_1.jsxs)(Typography_1.default, Object.assign({ variant: "subtitle2", id: "message-id", className: classes.message, color: 'textPrimary' }, { children: [(0, jsx_runtime_1.jsx)(Icon_1.default, Object.assign({ className: (0, classnames_1.default)(classes.icon, classes.iconVariant) }, { children: "check_circle" })), (0, jsx_runtime_1.jsx)("div", { dangerouslySetInnerHTML: {
                                    __html: t(message ? message.toString() : '', messageParams)
                                } }), messageParams && messageParams.linkAction ? ((0, jsx_runtime_1.jsx)(Link_1.default, Object.assign({ href: "javascript:;", onClick: messageParams.linkAction, color: 'inherit', className: classes.link }, { children: t(messageParams.linkText) }))) : null] })), action: [
                        (0, jsx_runtime_1.jsx)(IconButton_1.default, Object.assign({ "aria-label": "Close", color: "default", className: (0, classnames_1.default)(classes.close, 'iconButton'), onClick: this.onClose }, { children: (0, jsx_runtime_1.jsx)(Icon_1.default, Object.assign({ className: classes.icon }, { children: "close" })) }), "close")
                    ] }) })));
        };
        this.onClose = () => this.props.clearMessages();
    }
    componentDidMount() {
        var _a;
        (_a = this.ref.current) === null || _a === void 0 ? void 0 : _a.focus();
        const { messageTimeout, type } = this.props;
        if (type === 'error' && messageTimeout && messageTimeout > 0) {
            this.closeTimeout = setTimeout(this.onClose, messageTimeout);
        }
    }
    componentWillUnmount() {
        if (this.closeTimeout) {
            clearTimeout(this.closeTimeout);
        }
    }
    render() {
        return this.props.type === 'error' ||
            this.props.type === 'outage_warning' ||
            this.props.type === 'warning' ||
            this.props.type === 'success_embedded'
            ? this.renderStaticBar()
            : this.renderSnackBar();
    }
}
exports.default = (0, styles_1.withTheme)((0, styles_1.withStyles)(MessageBarStyle_1.default)((0, react_i18next_1.withTranslation)()(MessageBar)));
//# sourceMappingURL=MessageBar.js.map